import gql from 'graphql-tag'

export default gql`
mutation createEventDetailLink ($input: EventDetailLinkInput) {
  createEventDetailLink (input: $input) {
    id
    text
    url
    event_detail_id
  }
}
`


// WEBPACK FOOTER //
// ./src/apollo/graphql/event/createLink.js